import React, { useState, useEffect, useRef } from 'react';
import { css } from '@emotion/react';
import Close from '../svg/close-circle.svg';

export default function Gallery(props) {
  const [caption, setCaption] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    setCaption(props.children[0]?.props['data-caption']);
  }, [props.children]);

  useEffect(() => {
    ref.current?.children[props.current].scrollIntoView();
  }, [props.current]);

  return (
    <div
      ref={ref}
      onScroll={(e) => {
        e.persist();

        const children = Array.from(e.target.querySelectorAll('[data-caption]')).reverse();

        children.some((node) => {
          if (node.offsetTop <= e.target.scrollTop + window.innerHeight - (window.innerHeight / 4)) {
            setCaption(node.getAttribute('data-caption'));

            return true;
          }

          return false;
        });
      }}
      css={css`
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        text-align: center;
        background-color: var(--white);
        overflow-y: scroll;
        z-index: 99;
      `}
      className={props.className}
    >
      {props.children}
      <div
        css={css`
          position: fixed;
          top: var(--gutter);
          left: var(--gutter);
          cursor: pointer;

          @media (max-width: 1100px) {
            display: none;
          }

          &:hover {
            svg path {
              fill: var(--pink);
            }
          }

          svg path {
            fill: var(--20Brown);
          }
        `}
        onClick={() => props.setShowImages(false)}
      >
        <Close />
      </div>
      <div
        className="type--outline"
        css={css`
          position: fixed;
          right: calc((100vw - (var(--gutter) * 13)) / 12 * 2 + var(--gutter) * 2);
          bottom: var(--gutter);
          left: calc((100vw - (var(--gutter) * 13)) / 12 * 2 + var(--gutter) * 2);
          text-align: center;
        `}
      >
        {caption}
      </div>
    </div>
  )
}
